function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 189.81 189.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 94.9,
    cy: 94.9,
    r: 85.9,
    style: {
      fill: "#ebf3d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,189.81C42.57,189.81,0,147.23,0,94.9S42.57,0,94.9,0s94.9,42.57,94.9,94.9-42.57,94.9-94.9,94.9ZM94.9,9C47.54,9,9,47.54,9,94.9s38.54,85.9,85.9,85.9,85.9-38.54,85.9-85.9S142.27,9,94.9,9Z",
    style: {
      fill: "#7c9c3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.74,115.62c10.33-4.55,17.55-14.88,17.55-26.9,0-16.23-13.16-29.38-29.38-29.38s-29.38,13.16-29.38,29.38c0,12.09,7.31,22.48,17.75,26.99-18.64,4.69-36.11,19.34-36.11,35.5,0,9.83,23.87,21.91,47.75,22.09,23.87.17,47.75-11.57,47.75-21.39,0-16.34-17.25-31.6-35.91-36.29Z",
    style: {
      fill: "#7c9c3d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.0f4f5327ae419d0cb894892c16fdac8a.svg";
export { ForwardRef as ReactComponent };